import { createSlice } from '@reduxjs/toolkit'

export const initialState = {
    id: 0,
    first_name: '',
    last_name: '',
    email: '',
    role: '',
    super_user: false,
    company_id: null,
    customer_id: null,
}

export const userSlice = createSlice({
    name: 'auth/user',
    initialState,
    reducers: {
        setUser: (_, action) => action.payload,
        userLoggedOut: () => initialState,
    },
})

export const { setUser, userLoggedOut } = userSlice.actions

export default userSlice.reducer
